import { useField } from "formik";
import { toast } from "react-toastify";
import { SimpleFormControl } from "src/app/components/form/SimpleFormControl";
import { SimpleFormSelect, SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { read, utils } from "xlsx";
import SimpleLangCheck from "../SimpleLangCheck/SimpleLangCheck";

interface IUpsertKeywords {
    thematicsOptions?: SimpleFormSelectOption[];
    isLoading?: boolean;
    handleDisableButton?(disable: boolean): void;
}
const UpsertKeywords = (props: IUpsertKeywords) => {
    const { thematicsOptions = [], isLoading = false, handleDisableButton = () => {} } = props;
    const [, , fileWithKeywordHelperProps] = useField("fileWithKeyword");

    const handleFile = async (files: FileList | null) => {
        const columnsToUse = {
            volume: "Search Volume",
            kd: "Keyword Difficulty",
            keywords: "Keyword",
        };

        // check if exist files
        if (!files) return;
        const file = files[0];
        const fileName = file.name;
        // check if file is xlsx or xls
        if (!(fileName.includes(".xlsx") || fileName.includes(".xls"))) {
            handleDisableButton(true);
            toast.error("file need to be .xlsx or .xls");
            return;
        }

        const data = await file.arrayBuffer();
        const workbook = read(data);
        const dataToJson = utils.sheet_to_json<any>(workbook.Sheets[workbook.SheetNames[0]]);

        // check if has array
        if (dataToJson?.length == 0) {
            handleDisableButton(true);
            toast.error("file is empty");
            return;
        }

        // check if columns exist
        if (
            !dataToJson[0]?.hasOwnProperty(columnsToUse.volume) &&
            !dataToJson[0]?.hasOwnProperty(columnsToUse.kd) &&
            !dataToJson[0]?.hasOwnProperty(columnsToUse.keywords)
        ) {
            handleDisableButton(true);
            toast.error(`Columns "${columnsToUse.volume}" or "${columnsToUse.kd}" not exist`);
            return;
        }

        fileWithKeywordHelperProps.setValue(file);
        handleDisableButton(false);
    };

    return (
        <div>
            <SimpleFormSelect
                isLoading={isLoading}
                label="thematics"
                name="thematicId"
                values={thematicsOptions}
            />
            <SimpleLangCheck />
            <SimpleFormControl
                name="file"
                label="File"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleFile(event?.currentTarget?.files);
                }}
            />
        </div>
    );
};

export default UpsertKeywords;
